import styled, { css } from "styled-components";

const resetButtonStyles = css`
  margin: 0px;
  padding: 0px;
  border: 0px;
  background: none;
  cursor: pointer;
  text-decoration: none;
`;

const verticalPosition = {
  top: "flex-start",
  bottom: "flex-end",
  center: "center",
};

const horizontalPosition = {
  left: "flex-start",
  right: "flex-end",
  center: "center",
  space: "space-between",
};

export const Center = styled("div") <{
  vertical: "top" | "center" | "bottom";
  horizontal: "left" | "center" | "right" | "space";
  gap?: number;
  column?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: ${({ column }) => (column ? "column" : "row")};
  justify-content: ${({ horizontal }) => horizontalPosition[horizontal]};
  align-items: ${({ vertical }) => verticalPosition[vertical]};
  gap: ${({ gap }) => (gap ? gap : 0)}px;
`;

export const BigText = styled("span") <{ isRecorded: boolean }>`
  font-weight: 600;
  font-size: ${({ isRecorded }) => isRecorded ? "14px" : "18px"};
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 25px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    font-size: 14px;
  }

  p {
    &:first-child {
      margin-top: 0px;
    }
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;

export const Line = styled("div")`
  width: 100%;
  height: 1px;
  background-color: #d9dde6;
`;

export const CleanLink = styled.a`
  ${resetButtonStyles}
  color: inherit;

  i {
    display: inline-block;
    vertical-align: top;
  }
`;

export const FilesContainer = styled.div`
  width: 100%;
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const FileCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const FileThumbnail = styled.div<{ $backgroundUrl: string; $backgroundSize: string }>`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dbdbdb;
  background-image: url(${props => props.$backgroundUrl});
  background-position: center;
  background-size: ${props => props.$backgroundSize};
  background-repeat: no-repeat;
  background-color: white;
  flex-shrink: 0;
`;

export const FileDetails = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.Gray900};
  word-break: break-word;
`;

export const FileType = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.Gray600};
  margin-top: 4px;
`;

export const DownloadButton = styled.button<{ $isMobile?: boolean }>`
  padding: ${props => props.$isMobile ? '10px' : '8px 16px'};
  background-color: ${props => props.theme.colors.Primary};
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${props => props.$isMobile ? '40px' : 'auto'};
  min-height: ${props => props.$isMobile ? '40px' : 'auto'};

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
`;
